import { useState } from "react";
import { fmtCurrency } from "@/lib/format";

export const MONTHS = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
export const kEur = (v) => (v >= 1e6 ? `${(v / 1e6).toFixed(1).replace(".", ",")} M€` : `${Math.round(v / 1000)} k€`);
const mLabel = (ym) => MONTHS[Number(ym.slice(5, 7)) - 1];

const niceMax = (v) => {
  if (!v) return { max: 40000, step: 10000 };
  const raw = v / 4;
  const p = 10 ** Math.floor(Math.log10(raw));
  const step = [1, 2, 2.5, 5, 10].map((s) => s * p).find((s) => s >= raw);
  return { max: step * Math.ceil(v / step), step };
};

function Tip({ m }) {
  const lines = [m.billed_n && `Faturada: ${fmtCurrency(m.billed)} · ${m.billed_n} ${m.billed_n === 1 ? "escritura" : "escrituras"}`,
    m.forecast_n && `Prevista: ${fmtCurrency(m.forecast)} · ${m.forecast_n} ${m.forecast_n === 1 ? "escritura" : "escrituras"}`].filter(Boolean);
  return (
    <div className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 z-20 whitespace-nowrap rounded-lg navy-bg text-white text-xs px-3 py-2 shadow-lg pointer-events-none tabular-nums" data-testid="chart-tooltip">
      <div className="font-semibold">{mLabel(m.month)} {m.month.slice(0, 4)}</div>
      {lines.length ? lines.map((l) => <div key={l}>{l}</div>) : <div>Sem escrituras</div>}
    </div>
  );
}

export const CommissionChart = ({ data }) => {
  const [hover, setHover] = useState(null);
  const { max, step } = niceMax(Math.max(...data.map((m) => m.billed + m.forecast)));
  const ticks = Array.from({ length: Math.round(max / step) + 1 }, (_, i) => i * step).reverse();
  return (
    <div className="flex gap-2 flex-1 min-h-[190px] font-body" data-testid="commission-chart">
      <div className="flex flex-col justify-between text-[11px] text-slate-400 tabular-nums text-right w-11 shrink-0 pb-5 -mt-1.5">
        {ticks.map((t) => <span key={t}>{kEur(t)}</span>)}
      </div>
      <div className="flex-1 relative">
        <div className="absolute inset-x-0 top-0 bottom-5 flex flex-col justify-between pointer-events-none">
          {ticks.map((t) => <div key={t} className="border-t border-slate-100" />)}
        </div>
        <div className="absolute inset-x-0 top-0 bottom-0 flex">
          {data.map((m, i) => {
            const total = m.billed + m.forecast;
            return (
              <div key={m.month} className={`flex-1 flex flex-col relative ${m.offset === 0 ? "border-r border-dashed border-slate-400" : ""}`}
                onMouseEnter={() => setHover(i)} onMouseLeave={() => setHover(null)} data-testid={`chart-month-${m.month}`}>
                {m.offset === 0 && <span className="absolute right-1.5 top-7 text-[11px] text-slate-400" data-testid="chart-today">hoje</span>}
                <div className="flex-1 flex flex-col justify-end items-center px-[18%] relative">
                  {hover === i && <Tip m={m} />}
                  {(m.offset === 0 || m.offset === 1) && total > 0 && (
                    <span className="text-[10px] sm:text-[11px] font-semibold navy-text tabular-nums mb-1 whitespace-nowrap" data-testid={`chart-value-${m.offset}`}>{kEur(total)}</span>
                  )}
                  <div className="w-full flex flex-col justify-end transition-opacity" style={{ height: `${(total / max) * 100}%`, opacity: hover == null || hover === i ? 1 : 0.8 }}>
                    {m.forecast > 0 && <div className="w-full bar-brand-soft rounded-t-[3px]" style={{ flexGrow: m.forecast }} />}
                    {m.billed > 0 && <div className={`w-full bar-brand-v ${m.forecast ? "" : "rounded-t-[3px]"}`} style={{ flexGrow: m.billed }} />}
                  </div>
                </div>
                <span className="h-5 pt-1 text-[10px] sm:text-[11px] text-slate-400 text-center"><span className="hidden sm:inline">{mLabel(m.month)}</span><span className="sm:hidden">{mLabel(m.month)[0]}</span></span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
